<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>export default {
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理" },
        { name: "临期查询" },
      ],
      menuIndex: `/vehicle/documents/list`,
      menu: [
        {
          name: "证件",
          path: `/vehicle/documents/list`,
        },
        {
          name: "保险",
          path: `/vehicle/documents/insurancelist`,
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
